<template>
    <form-wrapper @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.auth.register.fields.email.label')"
                    :placeholder="$t('forms.auth.register.fields.email.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    :isDisabled="true"
                    valuePath="email"
                    type="email"
                ></text-field>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell>
                <text-field
                    :label="$t('forms.auth.register.fields.password.label')"
                    :placeholder="$t('forms.auth.register.fields.password.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    valuePath="password"
                    :type="passwordInputFieldType"
                    :maxLength="40"
                    @change="change($event)"
                >
                    <template #icon>
                        <common-toggle-visibility-button
                            @visibility-toggle-switch="showPassword"
                        ></common-toggle-visibility-button>
                    </template>
                </text-field>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell>
                <checkbox-field :formData="data" valuePath="agree" @change="change($event)">
                    <template #label>
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <span v-html="$t('forms.auth.register.fields.agree.label')"></span>
                    </template>
                </checkbox-field>
            </form-cell>
        </form-row>
        <template #footer>
            <common-buttons>
                <common-button
                    :isDisabled="isSubmitButtonDisabled(data)"
                    :isProcessing="isSending"
                    :label="$t('pages.auth.signup.steps.physician_password.button')"
                    type="primary"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'
    import PasswordToggleVisibilityMixin from 'mixins/PasswordToggleVisibilityMixin'
    import FormWrapper from '../../components/form-elements/FormWrapper'
    import FormRow from '../../components/form-elements/FormRow'
    import AuthAPI from 'api/AuthAPI'
    import FormCell from '../../components/form-elements/FormCell'

    export default {
        mixins: [FormMixin, PasswordToggleVisibilityMixin],

        components: {
            FormCell,
            FormRow,
            FormWrapper,
        },

        data() {
            return {
                isSending: false,
            }
        },

        methods: {
            handleFormSubmission() {
                this.isSending = true
                UsersAPI.setPhysicianPassword(this.$route.query.e, this.$route.query.p, this.data.password)
                    .then(() => {
                        this.handleRequest(AuthAPI.logIn(this.$route.query.e, this.data.password))
                            .then((AuthenticationResult) => {
                                const { accessToken, idToken, refreshToken } = AuthenticationResult.signInUserSession
                                this.$auth.logIn(accessToken.jwtToken, idToken.jwtToken, refreshToken.token)
                                this.emitEvent({ name: 'sent' })
                            })
                            .catch(() => {
                                this.errorMessage = this.$t('forms.auth.login.microcopy.not_found_error')
                                this.data.password = ''
                            })
                    })
                    .catch(() => (this.isSending = false))
            },

            isSubmitButtonDisabled(data) {
                return !(data.password && data.agree)
            },
        },

        mounted() {
            this.data.email = this.$route.query.e
        },
    }
</script>
